import { Spinner, Text, VStack } from '@chakra-ui/react'

export default () => {
  return (
    <VStack>
      <Spinner color='primary.500' />
      <Text>Loading...</Text>
    </VStack>
  )
}
